import { Badge, BadgeProps } from '@mui/material'
import { styled } from '@mui/styles'

export const CounterBadge = styled(Badge)<BadgeProps>({
  '& .MuiBadge-badge': {
    right: -12,
  },
})
